import { Component, OnInit, OnDestroy } from '@angular/core';
import { EmitterService } from '../services/emitter.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
@Component({
  selector: 'app-app-servererror-msg',
  templateUrl: './app-servererror-msg.component.html',
  styleUrls: ['./app-servererror-msg.component.scss']
})
export class AppServererrorMsgComponent implements OnInit, OnDestroy {

  serverErrorMsg: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private emitterService: EmitterService
  ) {
    this.emitterService.serverError$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if (status.length !== 0) {
        this.serverErrorMsg = status;
        // this.utility.openModal('servermsgmodal')
      }
    });
  }

  ngOnInit(){
    this.emitterService.serverError$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if (status.length !== 0) {
        this.serverErrorMsg = status;
        // this.utility.openModal('servermsgmodal')
      }
    });
  }
  ngOnDestroy(){
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
